// RUN BUILD WITH: ng build --configuration=dev

export const environment = {
  production: false,
  url: 'https://devcms.job.rocks/',
  apiUrl: 'https://devcms.job.rocks/api',
  ibanApi: "https://services.job.rocks/",
  chatUrl: "http://localhost:3000/",
  chatApiUrl: "http://localhost:3000/api",

  iosAppLink: "https://apps.apple.com/us/app/bejoo/id6749895236",
  androidAppLink: "https://play.google.com/store/apps/details?id=com.sihp.jobrocks.bejoo",

  // bejoo
  logoUrl: "assets/images/bejoo_logo.png",
  favIconUrl: "assets/images/bejoo-favicon.png",
  agencyName: "bejoo",

  // hotelis
  // logoUrl: 'assets/images/Logo_Hotelis_web_650x145px.png',
  // favIconUrl: 'assets/images/Logo_Hotelis_60x60px_3.png',
  // agencyName: 'Hotelis',

  // monitoring
  sentryDsn: 'https://3af19c63fd69f6191da152fcb513d320@o4511032735039488.ingest.de.sentry.io/4511038077534288',
  sentryEnvironment: 'dev',
};